/**
 * Hook which determines which bid report queries to use based on the user's
 * login status and whether or not they have a url share signature
 * @returns
 */
export function useExternalBidQuery(): {
  useExternalQuery: boolean;
  urlShareSignature: string | null;
  isLoggedIn: boolean;
} {
  const isLoggedIn = !!window.currentUser;

  const urlShareSignature = new URLSearchParams(window.location.search).get("sig");

  const useExternalQuery = !!urlShareSignature || !isLoggedIn;
  return { useExternalQuery, urlShareSignature, isLoggedIn };
}
